import React from 'react';
import styles from './OnboardingSimple.module.css';

interface OnboardingSimpleProps {
  onComplete: () => void;
}

const OnboardingSimple: React.FC<OnboardingSimpleProps> = ({ onComplete }) => {
  const botUsername = process.env.REACT_APP_BOT_USERNAME || 'settlerx_bot';
  
  const copyBotUsername = () => {
    navigator.clipboard.writeText(`@${botUsername}`);
    
    // Haptic feedback
    if (window.Telegram?.WebApp?.HapticFeedback) {
      window.Telegram.WebApp.HapticFeedback.notificationOccurred('success');
    }
    
    // Show feedback
    const btn = document.getElementById('copyBtn');
    if (btn) {
      btn.textContent = '✓ Copied!';
      setTimeout(() => {
        btn.textContent = `Copy @${botUsername}`;
      }, 2000);
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        {/* Hero */}
        <div className={styles.hero}>
          <div className={styles.icon}>💎</div>
          <h1 className={styles.title}>Welcome to Settler</h1>
          <p className={styles.subtitle}>
            Track group expenses with your friends right in Telegram
          </p>
        </div>

        {/* Steps */}
        <div className={styles.steps}>
          <div className={styles.step}>
            <div className={styles.stepNumber}>1</div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Add bot to your group</h3>
              <p className={styles.stepDesc}>
                Open any Telegram group → Add members → Search for <strong>@{botUsername}</strong>
              </p>
              <button 
                id="copyBtn"
                className={styles.copyBtn} 
                onClick={copyBotUsername}
              >
                Copy @{botUsername}
              </button>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>2</div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Grant admin rights</h3>
              <p className={styles.stepDesc}>
                <strong>⚠️ Important:</strong> Make the bot an admin so it can read messages and parse expenses automatically
              </p>
              <div className={styles.tip}>
                💡 Tap bot name → Edit Admin Rights → ✓ Enable all
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>3</div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Track expenses naturally</h3>
              <p className={styles.stepDesc}>
                Message the bot like you talk: "Coffee 5$" or "Pizza 50" or "Taxi 2000₽"
              </p>
              <div className={styles.examples}>
                <code>"Coffee 5$"</code>
                <code>"50 lunch"</code>
                <code>"5K taxi"</code>
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>4</div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Settle up instantly</h3>
              <p className={styles.stepDesc}>
                Pay debts with TON/USDT or mark as settled manually—all in one tap
              </p>
            </div>
          </div>
        </div>

        {/* Features */}
        <div className={styles.features}>
          <span className={styles.badge}>🤖 AI Parsing</span>
          <span className={styles.badge}>💎 TON & USDT</span>
          <span className={styles.badge}>🌍 Multi-currency</span>
        </div>

        {/* CTA */}
        <button className={styles.getStartedBtn} onClick={onComplete}>
          Got it! Let's start
        </button>
      </div>
    </div>
  );
};

export default OnboardingSimple;

